import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { GuardService } from 'src/app/core/services/guards.service';
import { IdleService } from 'src/app/core/services/idle.service';
import { globalConfig } from 'src/app/core/utils/globalConfig';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  http = inject(HttpClient);
  route = inject(Router);
  guardService = inject(GuardService);
  private idleService = inject(IdleService);

  toastMessage: string | null = null;

  constructor() {
  }

  #stateIndicativo = signal<any>({
    indicativo: [],
  });

  #stateUsuario = signal<any>({
    usuario: {},
  });

  #stateTipoDocumento = signal<any>({
    tipoDocumento: [],
  });

  public indicativo = computed(() => this.#stateIndicativo().indicativo);
  public usuario: any = computed(() => this.#stateUsuario().usuario);
  public tipoDocumento: any = computed(() => this.#stateTipoDocumento().tipoDocumento);

  login(loginData: any) {
    sessionStorage.removeItem(globalConfig.tokenApi);
    sessionStorage.removeItem(globalConfig.permisosUsuario)
    this.guardService.resetPermisos();
    return this.http.post('/auth/login-usuario-back', loginData);
  }

  logout() {
    sessionStorage.removeItem(globalConfig.tokenApi);
    sessionStorage.removeItem(globalConfig.permisosUsuario)
    this.guardService.resetPermisos()
    this.idleService.stopWatching();
    this.route.navigate(['/auth/sign-in']);
  }

  cambiarPasswordUsuarioBack(newPassword: string) {
    return this.http.patch('/usuario-back/nuevo-password', {
      password: newPassword,
    });
  }

  getIndicativo() {
    this.http
      .get('/pais/indicativos')
      .pipe(
        map(({ data }: any) => {
          let filter = [];
          const { id, indicativo, nombre } = data.find((country: { nombre: string }) => country.nombre === 'Colombia');
          filter.push({
            id,
            name: `+ ${indicativo} ${nombre}`,
            indicativo,
          });
          const countriesWithoutColombia = data.filter((country: { nombre: string; }) => country.nombre !== 'Colombia')
          for (const { id, indicativo, nombre } of countriesWithoutColombia) {
            filter.push({
              id,
              name: `+ ${indicativo} ${nombre}`,
              indicativo,
            });
          }
          return filter;
        }),
      )
      .subscribe((indicativo: any) => {
        this.#stateIndicativo.set({
          indicativo,
        });
      });
  }

  getTipoDocumento() {
    this.http
      .get('/tipo-documento')
      .pipe(
        map(({ data }: any) => {
          let filter = [];
          for (const { id, nombre } of data) {
            filter.push({
              id,
              name: nombre,
            });
          }
          return filter;
        }),
      )
      .subscribe((tipoDocumento: any) => {
        this.#stateTipoDocumento.set({
          tipoDocumento,
        });
      });
  }

  registrarDependencia(data: any) {
    return this.http.post('/usuario-cuenta-empresarial/registrar-dependencia', data);
  }

}
